/* Light YouTube Embeds by @labnol */
/* Web: http://labnol.org/?p=27941 */

// lazy-load youtube videos
document.addEventListener("DOMContentLoaded",
	function () {
		// Youtube
		var div, n, v = document.getElementsByClassName("youtube-player");
		for (n = 0; n < v.length; n++) {
			div = document.createElement("div");
			div.setAttribute("data-id", v[n].dataset.id);
			div.innerHTML = labnolThumb(v[n].dataset.id);
			div.onclick = labnolIframe;
			v[n].appendChild(div);
		}
  
  		// Vimeo
		var v2 = document.getElementsByClassName("lazy-vimeo-player");
		for (n = 0; n < v2.length; n++) {
            var vimeoId = v2[n].dataset.id;
			var vimeoPreviewDiv = document.createElement("div");
			vimeoPreviewDiv.setAttribute("data-id", vimeoId);
            vimeoPreviewDiv.onclick = vimeoIframe;
          	var vimeoThumb = document.createElement("img");
            vimeoThumb.setAttribute("loading","lazy");
            vimeoThumb.setAttribute("width",640);
            vimeoThumb.setAttribute("height",360);
            vimeoThumb.setAttribute("alt","Product Video");
          	vimeoThumb.setAttribute("data-vimeo-id",vimeoId);
            vimeoThumb.setAttribute("src","");
            vimeoPreviewDiv.appendChild(vimeoThumb);
          	//vimeoPreviewDiv.onclick = vimeoIframe;
          	v2[n].appendChild(vimeoPreviewDiv);
          
            var imgThumb = v2[n].dataset.thumb;
            if (typeof imgThumb != "undefined"){
              vimeoThumb.setAttribute("src",imgThumb);
            } 
            else {
              $.getJSON('https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + vimeoId, {
                format: "json",
                width: "640"
              },
              function(data) {
                $("img[data-vimeo-id=" + data.video_id + "]").attr('src', data.thumbnail_url_with_play_button);
              });
            }
		}

        // add green bullets
      /*
        $('ul.fa-ul li').each(function () {
          $(this).html('<i class="fa-li fa fa-check-circle"></i>' + $(this).html());
    	});
      */
        // hide link titles on hover
        $('a').hover( 
          function() {
                $(this).attr("org_title", $(this).attr('title'));
                $(this).attr('title', '');
          }, function() {
                $(this).attr('title', $(this).attr("org_title"));
          }
        );

      // hook up tsg accordion
      document.querySelectorAll(".tsg-question").forEach(question => {
        question.addEventListener("click", function() {
          const answer = this.nextElementSibling;
          const isOpen = answer.style.display === "block";
    
          // Close all answers before opening a new one (optional)
          document.querySelectorAll(".tsg-answer").forEach(a => a.style.display = "none");
          
          // Toggle the current answer
          answer.style.display = isOpen ? "none" : "block";
          
          // Remove active class from all the other questions
          document.querySelectorAll(".tsg-question").forEach(a => a.classList.remove("active"));
          if (!isOpen){
            // Toggle active class for styling
            this.classList.toggle("active");
            }
        });
      });

      
	});

function youtubeThumb(id) {
	var thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg">',
		play = '<div class="play"></div>';
	return thumb.replace("ID", id) + play;
}

function youtubeIframe() {
	var iframe = document.createElement("iframe");
	var embed = "https://www.youtube.com/embed/ID?rel=0&amp;showinfo=0";
	iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
	iframe.setAttribute("frameborder", "0");
	iframe.setAttribute("allowfullscreen", "1");
	this.parentNode.replaceChild(iframe, this);
}

function vimeoThumb(id) {
	var vimeoVideoInfoURL = "https://vimeo.com/api/oembed.json?url=http%3A//vimeo.com/" + id;
    var imgSrc;
	$.ajax({
		type: 'GET',
		url: vimeoVideoInfoURL,
		dataType: "json",
		success: function (data) {
            imgSrc = data.thumbnail_url_with_play_button;
		}
	});
  	return imgSrc;
}

function vimeoIframe() {
    var iframeContainer = document.createElement("div");
    iframeContainer.setAttribute("class", "vimeo-video-container");
  
	var iframe = document.createElement("iframe");
	var embed = "//player.vimeo.com/video/ID?autoplay=1&amp;loop=1&amp;";
    iframe.setAttribute("width", "640");
    iframe.setAttribute("height", "360");
	iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
	iframe.setAttribute("frameborder", "0");
	iframe.setAttribute("allowfullscreen", "1");
    iframe.setAttribute("allow","autoplay; fullscreen");
	
    iframeContainer.appendChild(iframe);
    this.parentNode.replaceChild(iframeContainer, this);
}

// lazy-load vimeo videos
/*
$(document).ready(function () {
	$('div.lazy_vimeo').each(function () {
		var id = $(this).data('vimeo-id'),
			iframe = $('<iframe width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen />');
		iframe.attr('src', "//player.vimeo.com/video/" + id + "?portrait=0&amp;badge=0&amp;color=a3cd3a");
		$(this).replaceWith(iframe);
	});
});
*/


function scrollToTabs() {
  //document.getElementById('productDescription').scrollIntoView();
   window.scrollBy({ top: 500, left: 0, behavior: 'smooth' });
}